import { Col, Container, Nav, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MercurXIcons from '../../MercurXIcons/MercurXIcons';

import './BannerToken.scss';
import { connect } from 'react-redux';
import { getSalesTitleFromPath, isNftSalesPath } from '../../../helpers/salesRoute';
import { useEffect } from 'react';
import { getProjectByID } from '../../../store/project/projectActions';

import MercurXSpinner from '../../MercurXSpinner/MercurXSpinner';

function BannerToken({ ...props }) {
  const { project, history, match, getProjectByIDRequest } = props;
  const pathname = history?.location?.pathname?.toLowerCase() || '';
  const routeProjectId = match?.params?.id;
  const routeProjectIdNumber = Number(routeProjectId);
  const hasMatchingProject = Number(project?.id) === routeProjectIdNumber;

  const isNftSalesProjectPage = isNftSalesPath(pathname);
  const salesTitle = getSalesTitleFromPath(pathname);

  useEffect(() => {
    if (!routeProjectId) {
      return;
    }

    if (!hasMatchingProject) {
      getProjectByIDRequest({ id: routeProjectId });
    }
  }, [routeProjectId, hasMatchingProject, getProjectByIDRequest]);

  if (!hasMatchingProject) {
    return <MercurXSpinner />;
  }

  const title = isNftSalesProjectPage
    ? project?.nft?.name || project?.name || `NFT Project #${routeProjectId || ''}`.trim()
    : project?.name;
  const description = project?.explanation_text || 'MercurX Sales Project';
  const social = project?.social;

  return (
    <>
      <Container className="token-banner">
        <Row className="text-fs-head-xs text-white">
          <Col>{`Home/${salesTitle}/Product Page`}</Col>
        </Row>
        <Row className="text-fs-title-md mt-4 text-white">
          <Col lg={12} md={12}>
            {title}
          </Col>
        </Row>
        <Row className="text-fs-body-md mt-4 text-white">
          <Col lg={4} md={6}>
            {description}
          </Col>
        </Row>
        {social ? (
          <Row className="text-fs-body-md mt-4">
            <Col className="token-banner-icon">
              <ul>
                {social.telegram ? (
                  <li>
                    <Nav.Link
                      as={Link}
                      to={{ pathname: social.telegram }}
                      target="_blank"
                    >
                      <MercurXIcons name="FaTelegram" color={'white'} size="46" />
                    </Nav.Link>
                  </li>
                ) : (
                  <></>
                )}
                {social.discord ? (
                  <li>
                    <Nav.Link as={Link} to={{ pathname: social.discord }} target="_blank">
                      <MercurXIcons name="FaDiscord" color={'white'} size="46" />
                    </Nav.Link>
                  </li>
                ) : (
                  <></>
                )}
                {social.twitter ? (
                  <li>
                    <Nav.Link as={Link} to={{ pathname: social.twitter }} target="_blank">
                      <MercurXIcons name="FaTwitter" color={'white'} size="46" />
                    </Nav.Link>
                  </li>
                ) : (
                  <></>
                )}
              </ul>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </Container>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    project: state.projectReducer.project,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectByIDRequest: (payload) => {
      dispatch(getProjectByID(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerToken);
